<template>
  <div>
    <TopBar :pagetitle="title" :back-url="backurl" right="iconadd" @rightClick="onAdd" />
    <div class="listBody">
      <van-list
        v-model="loading"
        :finished="finished"
        finished-text="没有更多了"
        @load="onLoad"
      >
        <div v-for="item in list" :key="item.teachingId" class="teaching">
          <van-row>
            <van-col span="12">教练:{{ item.proUserName }}</van-col>
            <van-col span="12" class="textRight">{{ formatDate(item.createTime,"yyyy-MM-dd hh:mm:ss",true) }}</van-col>
          </van-row>
          进度:{{ item.body }}
        </div>
      </van-list>
    </div>
  </div>
</template>
<script>
import request from '@/utils/request'
import TopBar from '@/components/TopBar'
import { initPage, getUrlKey, formatDate } from '@/utils/base'
import { List } from 'vant'
export default {
  components: {
    [List.name]: List,
    TopBar
  },
  data() {
    return {
      title: '教学进度',
      backurl: '/textbook/teachingProgressList',
      id: undefined,
      list: [],
      loading: false,
      finished: false,
      search: {
        limit: 30,
        page: 1,
        id: undefined
      }
    }
  },

  created() {
    initPage()
    this.id = this.$route.params.id
    this.search.id = this.id
    var url = getUrlKey('backurl')
    if (url !== null) {
      this.backurl = url
    }
    this.list = []
    this.onLoad()
  },
  methods: {
    formatDate,
    onAdd() {
      this.$router.replace('/textbook/teachingProgressAdd/' + this.id + '?backurl=' + this.backurl)
    },
    onLoad() {
      this.loading = true
      request({
        url: '/Course/getTeachingProgressTextbookList',
        method: 'post',
        data: this.search
      }).then(response => {
        if (!response.success) {
          this.error = true
          return
        }
        this.loading = false
        this.search.limit = response.data.limit
        this.search.page = response.data.page + 1
        response.data.rows.forEach(item => {
          this.list.push(item)
        })
        if (response.data.rows.length < this.search.limit) {
          this.finished = true
        }
      })
    }
  }
}
</script>
<style scoped>
.serType{
  position: fixed;
  left: 0;
  top: 3em;
  right: 0;
  height: 2em;
}
.listBody{
   margin-top: 0.8em;

}
.teaching{
  margin-top: 0.8em;
  font-size: 0.9em;
  line-height: 1.6em;
  padding: 0.5em 1em;
  background-color: #fff;
  border-top: 1px solid #ddd;
}
</style>
